const actions_schema = action_functions => [
  {
    label: "Edit",
    color: "#0071BB",
    action: action_functions.edit
  },
  {
    label: "Delete",
    color: "#9C1712",
    action: action_functions.delete
  }
];

export default actions_schema;
